// extracted by mini-css-extract-plugin
module.exports = {"vedioPlayerWrapper":"videoPlayer_vedioPlayerWrapper__2WpFW","hide":"videoPlayer_hide__31_lS","closeBtn":"videoPlayer_closeBtn__2gNWE"};